
import customerAcquisition from 'images/services/customer-acquisition.svg';
import customerRetention from 'images/services/customer-retention.svg';
import marketingAutomation from 'images/services/marketing-automation.svg';

import marketingAnalytics from 'images/services/marketing-analytics.svg';
import funnelAnlysis from 'images/services/funnel-anlysis.svg';

import dataWarehouses from 'images/services/data-warehouses.svg';
import dataPipelines from 'images/services/data-pipelines.svg';
import developmentOperations from 'images/services/development-operations.svg';


export default {
  header: {
    title: 'Leverage data engineering to increase advertising ROI.',
    description: "We continuously deliver accurate data and reports.  That way your advertising team can focus on analysis and decision making.",
    refButtons: [{
      title: 'GROWTH MARKETING',
      ref: 'marketing',
    }, {
      title: 'CUSTOMER ANALYTICS',
      ref: 'analytics',
    }, {
      title: 'DATA ENGINEERING',
      ref: 'engineering',
    }],
  },
  contentBlocks: [{
    title: 'Growth Marketing',
    ref: 'marketing',
    description: 'Developing automated processes for customer acquisition and retention increases growth trajectory.  Iterio will recommend and help implement battle-tested strategies.',
    modifier: 'green',
    talkButton: true,
    blocks: [{
      title: 'Customer Acquisition',
      icon: customerAcquisition,
      bullets: [
        'Build target audiences to find new customers.',
        'Identify and test new traffic sources.',
        'Measure cost of acquisition and ROI.',
      ],
    }, {
      title: 'Customer Retention',
      icon: customerRetention,
      bullets: [
        'Measure customer retention and churn.',
        'Target campaigns for customers at risk.',
        'Identify triggers causing customer loss.',
      ],
    }, {
      title: 'Marketing Automation',
      icon: marketingAutomation,
      bullets: [
        'Build granular segments to target campaign content and timing.',
        'Automate advertising operations via advertiser APIs.',
        'Custom integration w/ your CRM of choice.',
      ],
    }],
  }, {
    title: 'Customer Analytics',
    ref: 'analytics',
    description: 'Measuring KPIs will enable you to make confident marketing decisions.  Most businesses require similar metrics and we have algorithms ready to go.',
    modifier: 'dark-blue',
    talkButton: true,
    blocks: [{
      title: 'Cohort Analysis',
      icon: marketingAnalytics,
      bullets: [
        'Learn how customer behavior evolves over time.',
        'Measure rate of return on campaign spend.',
        'Identify your most profitable customer segments.',
      ],
    }, {
      title: 'Funnel Analysis',
      icon: funnelAnlysis,
      bullets: [
        'Measure and monitor marketing funnels.',
        'Identify drop-off points to increase conversions.',
        'Run experiments to boost conversion rates.',
      ],
    }],
  }, {
    title: 'Data Engineering',
    ref: 'engineering',
    description: 'The foundation of quantitative marketing is a data warehouse.  Iterio will build and manage this infrastructure.  Then teach you how to use it.',
    modifier: 'blue',
    talkButton: false,
    blocks: [{
      title: 'Data Warehouses',
      icon: dataWarehouses,
      bullets: [
        'Provide a complete and trustworthy customer dataset.',
        'Enable company-wide access to customer data.',
        'Use your existing data warehouse or have Iterio build and manage one for you.',
      ],
    }, {
      title: 'Data Pipelines',
      icon: dataPipelines,
      bullets: [
        'Easily collect customer data from any source.',
        'Automate event tracking and ETL to free up your development team.',
        'Get your data in real-time instead of waiting on developers.',
      ],
    }, {
      title: 'Continuous Delivery',
      icon: developmentOperations,
      bullets: [
        'Deploy new code faster than your competition.',
        'Implement software testing to ensure product quality.',
        'Monitor system uptime and performance.',
      ],
    }],
  }],
  footer: {
    title: 'Let us help you build a data strategy that profits.',
  },
};



// WEBPACK FOOTER //
// ./src/config/services.js